module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.contractLineItems), function(lineItem, index) {
    return _c('div', {
      key: index,
      staticClass: "ph3 flex flex-column justify-center"
    }, [_c('div', {
      staticClass: "flex justify-between items-center responsive-text"
    }, [_c('span', {
      staticClass: "mb1"
    }, [_vm._v(_vm._s(lineItem.product.friendly_name))]), _vm._v(" "), (!_vm.isBilledByPartner) ? _c('span', [_vm._v("$" + _vm._s(_vm.lineItemPrice(lineItem.product_price.current_price)))]) : _vm._e()]), _vm._v(" "), (!_vm.isBilledByPartner) ? _c('div', {
      staticClass: "flex justify-between"
    }, [_c('span', {
      staticClass: "description"
    }, [_vm._v("\n        " + _vm._s(_vm.lineItemDescription(lineItem.product_price)) + "\n      ")]), _vm._v(" "), _vm._t("changePlan")], 2) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04971ff0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/plans/ContractLineItems.vue
// module id = 1145
// module chunks = 0